import { Fragment, useMemo } from 'react';
import { TabContent } from '@pocketlaw/tetris';
import { EmptyList } from 'app/domains/tasks/components/EmptyList';
import { filterTasks } from '../../utils/filterTasks';
import { TaskList } from '../TaskList';
import { useTasks } from '../TasksProvider';
import { TabState } from '../types';
function TaskTabs(props) {
    const { hideSortSelector } = props;
    const { tasks, handleSelectTask } = useTasks();
    const { uncompletedTasks, completedTasks } = useMemo(() => filterTasks(tasks.data), [tasks.data]);
    if (tasks.loading || tasks.error) {
        return null;
    }
    return (<Fragment>
      <TabContent tabId={TabState.UNCOMPLETED}>
        {uncompletedTasks.length > 0 ? (<TaskList tasks={uncompletedTasks} onClick={handleSelectTask} hideSortSelector={hideSortSelector}/>) : (<EmptyList />)}
      </TabContent>
      <TabContent tabId={TabState.COMPLETED}>
        {completedTasks.length > 0 ? (<TaskList tasks={completedTasks} onClick={handleSelectTask} hideSortSelector={hideSortSelector}/>) : (<EmptyList completed/>)}
      </TabContent>
    </Fragment>);
}
export { TaskTabs };
